import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import SignUpComponent from './SignUpComponent';

class SignUp extends React.Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleGoogleSuccess = this.handleGoogleSuccess.bind(this);
        this.handleGoogleFailure = this.handleGoogleFailure.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.handleMicrosoftLogin = this.handleMicrosoftLogin.bind(this);
        this.gotToForgotPassword = this.gotToForgotPassword.bind(this);
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.onload = () => {
            this.googleAuthClient = window.google.accounts.oauth2.initCodeClient({
                client_id: "964252966658-8c590709chc294dsmm5hrc9qg7kvsoab.apps.googleusercontent.com",
                scope: "openid email profile",
                callback: this.handleGoogleSuccess,
                redirect_uri: "http://localhost:3000",
            });
        };
        document.body.appendChild(script);
    }

    handleGoogleSuccess(response) {
        if (response.code) {
            const idToken = response.code;
            let fromUrl = null;
            if (this.props.location.state && this.props.location.state.from) {
                fromUrl = this.props.location.state.from.pathname;
            }
            dispatch.login.googleLoginAsync({ idToken, fromUrl });
        }
    }

    handleGoogleFailure(error) {
        console.error('Google login failed', error);
    }

    handleGoogleLogin() {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback`;
        const scope = "openid email profile";
        const responseType = "code";
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    }

    async handleMicrosoftLogin() {
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback/microsoft`;
        const scope = "openid profile User.Read";
        const responseType = "code";
        const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    }

    onSubmit(formData) {
    }

    gotToForgotPassword(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/login');
    }

    componentWillMount() {
        dispatch.app.cacheCleanup();
        dispatch.login.getVersion();
    }

    render() {
        return (
            <SignUpComponent
                loggingIn={this.props.loggingIn}
                loginError={this.props.loginError}
                onSubmit={this.onSubmit}
                handleGoogleLogin={this.handleGoogleLogin}
                handleMicrosoftLogin={this.handleMicrosoftLogin}
                gotToForgotPassword={this.gotToForgotPassword}
                version={this.props.version}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.loading.effects.register.registerAsync,
        loginError: state.register.registerError,
        version: state.login.version
    };
}

const connectedSignUpPage = connect(mapStateToProps)(SignUp);
export { connectedSignUpPage as SignUp };